import { combineReducers } from 'redux';
import { createReducerManager } from './reduce-manager'

import ui from './modules/ui/reducers'
import games from './modules/game/reducers'
import user from './modules/user/reducers'

const reducerManager = createReducerManager({
  ui: ui,
  games: games,
  user: user
})

export default reducerManager
